import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { parsePriceMXN, formatMXN } from '../lib/utils';

const MiniCartBar = () => {
  const { items } = useCart();
  const location = useLocation();

  if (items.length === 0) return null;
  if (location.pathname === '/carrito') return null;

  const total = items.reduce((sum, i) => sum + parsePriceMXN(i.price) * i.qty, 0);

  return (
    <div className="q-minicart" data-testid="mini-cart-bar">
      <div className="q-minicart__inner">
        <span className="q-minicart__info">
          <ShoppingBag size={16} strokeWidth={1.5} />
          {items.length} {items.length === 1 ? 'pieza' : 'piezas'} guardada{items.length === 1 ? '' : 's'} · ${formatMXN(total)} MXN
        </span>
        <Link to="/carrito" className="q-btn q-btn--gold q-btn--sm" data-testid="mini-cart-view-link">
          Ver mi carrito →
        </Link>
      </div>
    </div>
  );
};

export default MiniCartBar;
